// PostDetail.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Post from '../container/Post.js';
import Redirect from '../container/Redirect.js';

import {
  headerHeight,
  footerNavigationHeight,
  iPhoneXSeriesFooterPaddingInPWA,
} from '../style/variables.js';
import media from '../style/media.js';

import { getIsIphoneXSeriesPWA } from '../resource/getUserAgent.js';
import { ProductType, SHOP_ID } from '../resource/shopConstants.js';
import withFetchTranslation from '../resource/withFetchTranslation.js';

import errorRoute from '../resource/errorRoute.js';

class PostDetail extends React.PureComponent {
  constructor(props) {
    super(props);
    // fetch data for SSR
    const {
      staticContext,
      messageId,
      defaultSubscriptionCurrency,
      isSubscriptionProductFetched,
      fetchMessageDetail,
      fetchUser,
      fetchDiamondPacks,
      senderId,
      senderName,
      detailError,
    } = props;
    if (staticContext.actions) {
      if (detailError) {
        staticContext.error = detailError;
      }
      if (messageId && !senderId) {
        staticContext.actions.push({
          function: fetchMessageDetail,
          argumentObject: {
            messageId,
            httpProxyHeaders: staticContext.httpProxyHeaders,
          },
        });
      }
      if (senderId && !senderName) {
        staticContext.actions.push({
          function: fetchUser,
          argumentObject: {
            id: senderId,
            httpProxyHeaders: staticContext.httpProxyHeaders,
          },
        });
      }
      if (senderId && !isSubscriptionProductFetched) {
        staticContext.actions.push({
          function: fetchDiamondPacks,
          argumentObject: {
            currency: defaultSubscriptionCurrency,
            shopId: SHOP_ID.subscription,
            type: ProductType.SUBSCRIPTIONS,
            productIds: [senderId],
            httpProxyHeaders: staticContext.httpProxyHeaders,
          },
        });
      }
    }
  }

  render() {
    const {
      chatroomId,
      messageId,
      detailError,
      isChatroomMessageLayout,
      shouldShowChatroomMediaLibrary,
    } = this.props;
    if (detailError?.message) {
      const { path, status } = errorRoute(detailError?.message);

      return <Redirect to={path} status={status} replace />;
    }

    return (
      <StyledPostDetail shouldPadFooter={getIsIphoneXSeriesPWA()}>
        <Body>
          <Container>
            <PostWrapper>
              <Post
                chatroomId={chatroomId}
                messageId={messageId}
                shouldShowMedias
                shouldShowSubscribeAndUnlock
                isChatroomMessageLayout={isChatroomMessageLayout}
                shouldShowChatroomMediaLibrary={shouldShowChatroomMediaLibrary}
              />
            </PostWrapper>
          </Container>
        </Body>
      </StyledPostDetail>
    );
  }
}

PostDetail.propTypes = {
  staticContext: PropTypes.object,
  chatroomId: PropTypes.string,
  messageId: PropTypes.string,
  detailError: PropTypes.instanceOf(Error),
  senderName: PropTypes.string,
  senderId: PropTypes.string,
  defaultSubscriptionCurrency: PropTypes.string,
  isSubscriptionProductFetched: PropTypes.bool,
  isChatroomMessageLayout: PropTypes.bool,
  shouldShowChatroomMediaLibrary: PropTypes.bool,
  fetchMessageDetail: PropTypes.func,
  fetchUser: PropTypes.func,
  fetchDiamondPacks: PropTypes.func,
};

PostDetail.defaultProps = {
  staticContext: {},
  chatroomId: null,
  messageId: null,
  detailError: null,
  originalTitle: '',
  captionText: '',
  senderName: '',
  senderId: '',
  defaultSubscriptionCurrency: null,
  isSubscriptionProductFetched: false,
  isChatroomMessageLayout: false,
  shouldShowChatroomMediaLibrary: false,
  fetchMessageDetail: () => null,
  fetchUser: () => null,
  fetchDiamondPacks: () => null,
};

const StyledPostDetail = styled.div`
  padding-top: calc(${headerHeight}px + var(--space-to-pinned-notification));
  padding-bottom: 0;
  ${media.mobile`
    padding-bottom: ${({ shouldPadFooter }) =>
      footerNavigationHeight +
      (shouldPadFooter ? iPhoneXSeriesFooterPaddingInPWA : 0)}px;
  `};
  min-height: 100vh;
`;

const Body = styled.main``;

const Container = styled.div`
  max-width: unset;
  margin: unset;

  height: calc(100vh - ${headerHeight}px);
  width: 100%;
  background: #191919;

  ${media.tablet`
    max-width: 680px;
    margin: 0 auto;
    height: unset;
  `}
`;

const PostWrapper = styled.div`
  padding-top: unset;
  margin-bottom: unset;
  height: 100%;

  ${media.tablet`
    padding-top: 16px;
    margin-bottom: 12px;
    height: auto;
  `}
`;

export default withFetchTranslation(PostDetail);
